:host {
  z-index: var(--vm-media-z-index);
}
